function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import get from 'get-value';
import classnames from 'classnames';
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { ResponsiveImage } from "../ResponsiveImage";
import { ICON_NAMES } from "../../elements/Icon";
import { testidFactory } from "../../../utils/testid";
import { adaptImages } from "./utils/adaptImages";
import { renderNavButton } from "./utils/renderNavButton";
var TEST_ID_PREFIX = 'slideshow';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var className = _ref.className,
      hasShadow = _ref.hasShadow,
      headingText = _ref.headingText,
      images = _ref.images,
      isRounded = _ref.isRounded,
      isShowingBulletNavigation = _ref.isShowingBulletNavigation,
      isShowingIndex = _ref.isShowingIndex,
      isShowingThumbnails = _ref.isShowingThumbnails,
      isStretched = _ref.isStretched,
      isFluid = _ref.isFluid,
      startIndex = _ref.startIndex,
      willFill = _ref.willFill;

  var _useState = useState(startIndex),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var onSlide = function onSlide(index) {
    setIndex(index);
  };

  var adaptedImages = useMemo(function () {
    return adaptImages(images);
  }, [images]);
  var descriptionText = get(images, [index, 'descriptionText']);
  return React.createElement(Fragment, null, headingText && React.createElement(Heading, null, headingText), descriptionText && React.createElement(Paragraph, null, React.createElement("span", {
    "data-testid": testid('description')
  }, descriptionText)), React.createElement(ImageGallery, {
    additionalClass: classnames(className, {
      'fit-height': isStretched,
      'fit-width': isFluid,
      'no-shadow': !hasShadow,
      'no-border-radius': !isRounded
    }),
    "data-testid": testid(),
    items: adaptedImages,
    lazyLoad: true,
    onSlide: onSlide,
    renderItem: function renderItem(item) {
      return React.createElement(ResponsiveImage, {
        imageUrl: item.original,
        placeholderImageUrl: item.placeholder,
        sizes: item.sizes,
        srcSet: item.srcSet,
        willFill: willFill
      });
    },
    renderLeftNav: renderNavButton(ICON_NAMES.CHEVRON_LEFT),
    renderRightNav: renderNavButton(ICON_NAMES.CHEVRON_RIGHT),
    showBullets: isShowingBulletNavigation,
    showFullscreenButton: false,
    showIndex: isShowingIndex,
    showPlayButton: false,
    showThumbnails: isShowingThumbnails,
    startIndex: startIndex,
    thumbnails: adaptedImages
  }));
};
Component.displayName = 'Slideshow';
Component.defaultProps = {
  className: null,
  hasShadow: true,
  headingText: null,
  isRounded: true,
  isShowingBulletNavigation: true,
  isStretched: false,
  isShowingIndex: false,
  isShowingThumbnails: false,
  isFluid: false,
  startIndex: 0,
  willFill: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  hasShadow: PropTypes.bool,
  headingText: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    descriptionText: PropTypes.string,
    placeholderUrl: PropTypes.string,
    sizes: PropTypes.string,
    srcSet: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string.isRequired
  })).isRequired,
  isFluid: PropTypes.bool,
  isRounded: PropTypes.bool,
  isShowingBulletNavigation: PropTypes.bool,
  isShowingIndex: PropTypes.bool,
  isShowingThumbnails: PropTypes.bool,
  isStretched: PropTypes.bool,
  startIndex: PropTypes.number,
  willFill: PropTypes.bool
} : {};